export const getRatingText = (params: {
  ratingSum: number;
  ratingCount: number;
}) => {
  const {ratingSum, ratingCount} = params;

  let calculatedRating = ratingSum / ratingCount;

  if (ratingSum === 0 || ratingCount === 0) {
    calculatedRating = 0;
  }

  calculatedRating = Math.round(calculatedRating * 10) / 10;

  return String(calculatedRating.toFixed(1));
};
